import React, { FC } from 'react'
import stripMarkdown from 'components/shared/utils/stripMarkdown'
import { logoUrl } from 'shared/util'

export interface ArticleJsonLdProps {
  keyOverride?: string
  url: string
  title: string
  images?: ReadonlyArray<string>
  authorName?: string | string[]
  description: string
  publisherName?: string
}

export const ArticleJsonLd: FC<ArticleJsonLdProps> = ({
  keyOverride,
  url,
  title,
  images = [],
  authorName = 'Fintrakk Admin',
  description,
  publisherName = 'Fintrakk',
}) => {
  const jsonld = `{
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "${url}"
    },
    "headline": "${title}",
    "image": [
      ${images.map((image) => `"${image}"`)}
     ],
    "author": "${authorName}",
    "publisher": {
      "@type": "Organization",
      "name": "${publisherName}",
      "logo": {
        "@type": "ImageObject",
        "url": "${logoUrl}"
      }
    },
    "description": ${stripMarkdown(description)}
  }`

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: jsonld }}
      key={`jsonld-article${keyOverride ? `-${keyOverride}` : ''}`}
    />
  )
}
